module.exports = __webpack_public_path__ + "static/media/send-icon.298632a7.svg";